export const updateObject = <T extends Record<string, any>>(
  oldObject: T,
  updatedProperties: Partial<T> | undefined
): T => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const updateObjectInArray = <T extends { id?: any }>(
  array: T[],
  updatedItem: Partial<T> & { id?: any }
): T[] => {
  return array.map((item) => {
    if (item.id !== updatedItem.id) return item;
    return { ...item, ...updatedItem };
  });
};
